export const getSelectedSalesSpaceChannelsGrouping = (state) =>
  state.salesSpaceChannels.selectedSalesSpaceChannelsGrouping;
